<template>
  <div class="home">
      {{message}}
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  components: {
  },
  data() {
      return {
          message:'test'
      }
  },
  mounted(){
    
  },
  watch:{
    $route:{
      handler:function(to,from){
        console.log(to,from)
      },
      deep:true
    }
  }
}
</script>
